/* eslint-disable max-len */
/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { Grid, Tooltip, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomSwitch from '../../../../../BussinessCertification/components/CustomSwitch';
import SelectSearchParticipants from '../../Reusable/SelectSearchParticipants';

interface FormData {
    title: string;
    description: string;
    enabled: boolean;
    allowShare: boolean;
    visibility: 'public' | 'private';
}

interface PermissionTogglesProps {
    formData: FormData;
    onUpdate: (field: keyof FormData, value: any) => void;
    language: any;
    onSpecificUsersUpdate: (users: any[]) => void;
    onDepartmentsUpdate: (category: string, selectedChips: Record<string, string[]>) => void;
    onRelationsUpdate: (relations: string[]) => void;
    specificUsers: any[];
    selectedDepartments: string[];
    selectedRelations: string[];
    isSubcategory: boolean;
    sliderEdit?: boolean;
    isAllEmployeesSelected?: boolean;
}

const PermissionToggles: React.FC<PermissionTogglesProps> = memo(({
	formData,
	onUpdate,
	language,
	onSpecificUsersUpdate,
	onDepartmentsUpdate,
	onRelationsUpdate,
	specificUsers,
	isAllEmployeesSelected,
	selectedDepartments,
	selectedRelations,
	sliderEdit = false,
	isSubcategory = false
}) =>
{
	// Create explicit handlers for each toggle to ensure state updates are captured correctly
	// const handleAllowDownloadsToggle = () =>
	// {
	// 	const newValue = !formData.allowDownloads;

	// 	console.log(`Toggling allowDownloads from ${formData.allowDownloads} to ${newValue}`);
	// 	onUpdate('allowDownloads', newValue);
	// };

	const handleAllowShareToggle = () =>
	{
		const newValue = !formData.allowShare;
		console.log(`Toggling allowShare from ${formData.allowShare} to ${newValue}`);
		onUpdate('allowShare', newValue);
	};

	return (
		<>
			<Grid container alignItems='center' justifyContent='space-between' pt={1}>
				<Grid item>
					<Tooltip title={language?.enableDec} placement='right'>
						<Typography variant='body1' fontWeight={500}>
							{language?.enable} <InfoOutlinedIcon fontSize='small' sx={{ verticalAlign: 'middle', ml: 0.5, color: '#737373' }} />
						</Typography>
					</Tooltip>
				</Grid>
				<Grid item>
					<CustomSwitch
						toggleEnabled={formData.enabled}
						handleToggleChange={() => onUpdate('enabled', !formData.enabled)}
					/>
				</Grid>
			</Grid>

			{/* <Grid container alignItems='center' justifyContent='space-between' mt={1}>
				<Grid item>
					<Tooltip title={language?.allowDwldDec} placement='right'>
						<Typography variant='body1' fontWeight={500}>
							{language?.allowDwld} <InfoOutlinedIcon fontSize='small' sx={{ verticalAlign: 'middle', ml: 0.5, color: '#737373' }} />
						</Typography>
					</Tooltip>
				</Grid>
				<Grid item>
					<CustomSwitch
						toggleEnabled={formData.allowDownloads}
						handleToggleChange={handleAllowDownloadsToggle}
					/>
				</Grid>
			</Grid> */}

			<Grid container alignItems='center' justifyContent='space-between' mt={1}>
				<Grid item>
					<Tooltip title={language?.allowshareDec} placement='right'>
						<Typography variant='body1' fontWeight={500}>
							{language?.allowShare} <InfoOutlinedIcon fontSize='small' sx={{ verticalAlign: 'middle', ml: 0.5, color: '#737373' }} />
						</Typography>
					</Tooltip>
				</Grid>
				<Grid item>
					<CustomSwitch
						toggleEnabled={formData.allowShare}
						handleToggleChange={handleAllowShareToggle}
					/>
				</Grid>
			</Grid>

			{!isSubcategory && (
				<Grid container alignItems='center' justifyContent='space-between' mt={1}>
					<Grid item>
						<Tooltip title={language?.enbleprivate} placement='right'>
							<Typography variant='body1' fontWeight={500}>
								{language?.visibility} <InfoOutlinedIcon fontSize='small' sx={{ verticalAlign: 'middle', ml: 0.5, color: '#737373' }} />
							</Typography>
						</Tooltip>
					</Grid>
					<Grid item>
						<RadioGroup
							row
							value={formData.visibility}
							onChange={(e) => onUpdate('visibility', e.target.value)}
						>
							<FormControlLabel value='public' control={<Radio color='primary' />} label={language?.public} />
							<FormControlLabel value='private' control={<Radio />} label={language?.private} />
						</RadioGroup>
					</Grid>
				</Grid>
			)}
			{formData.visibility === 'private' && !isSubcategory && (
				<Grid container>
					<SelectSearchParticipants
						onParticipantsSelected={onSpecificUsersUpdate}
						onDepartmentsSelected={onDepartmentsUpdate}
						onRelationsSelected={onRelationsUpdate}
						initialInternalEmployees={{
							specificUsers : specificUsers.map((user) => ({
								userId : user.userId,
								name   : user.name,
								email  : user.email,
								role   : user.role
							})),
							departments : selectedDepartments.map((dept) => ({ name: dept })),
							allSelected : isAllEmployeesSelected
						}}
						initialUserGroups={selectedRelations.map((relation) => ({ type: relation }))}
						isEdit={sliderEdit}
					/>
				</Grid>
			)}
		</>
	);
});

export default PermissionToggles;